export default  {
  bindings: {
    propertyGroup: '=',
    properties: '<'
  },
  controller: 'propertyGroupFormController',
  template: require('../views/property.group.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.group.form.component.js